// @flow
import * as React from 'react';
import cuid from 'cuid';

import Dropdown from '../Dropdown';
import { ActionBarStateConsumer } from '../../context/actionBarState.context';
import type { CommonActionProps } from './types.actions';
import { DesktopView } from '../../config/mediaQuery';

export default class StateSelector extends React.Component<CommonActionProps> {
  render() {
    return (
      <ActionBarStateConsumer>
        {({
          onChangeTerritorialState,
          territorialState,
          territorialStates,
        }: any) => {
          if (!onChangeTerritorialState) return null;

          return (
            <DesktopView>
              {(isDesktop) => (
                <Dropdown
                  disabled={this.props.disabled}
                  onChange={onChangeTerritorialState}
                  selected={territorialState}
                  options={territorialStates}
                  id={cuid()}
                  title={isDesktop ? "State" : null}
                />
              )}
            </DesktopView>
          );
        }}
      </ActionBarStateConsumer>
    );
  }
}
